import template from './open_notification_dialog.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';
import tr from '../../lib/default-translator.js';

class OpenNotificationViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.notifications = ko.observableArray();
		this.employee_id = ko.observable();
		this.data = ko.observable();
	};

	close()
	{
		this.dialog.close();
	}

	async delete_notification()
	{
		let res = await Grape.fetches.postJSON('/notifications/delete_notification', this.data());
		if (res.status !== 'ERROR')
		{
			Navbar.updateNotificationCount();
			this.dialog.close();
		}
		else
			Grape.alerts.alert({type: 'error', title: 'Error', message: tr('Error occurred while deleting notification..')});
	};
};

class OpenNotification
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new OpenNotificationViewModel(this);
		this.name = 'OpenNotification';
		this.viewModel.employee_id(Utils.get_local_storage_nullable('employee_id'));
	};

	async init()
	{
		if (this.viewModel.employee_id() == null || this.viewModel.employee_id() == 0)
			this.viewModel.employee_id(0);

		await this.updateData();

		window.addEventListener('hashchange', () => {
			this.close();
		});
	};

	async updateData()
	{
		this.viewModel.notifications([{
			'notifications_id': this.bindings.data.notifications_id,
			'message': this.bindings.data.message,
			'subject': this.bindings.data.subject,
			'sub_title': this.bindings.data.sub_title,
			'notifications_category': this.bindings.data.notifications_category,
			'notifications_status': this.bindings.data.notifications_status,
			'date_sent': this.bindings.data.date_sent
		}]);

		let data = {
			employee_id: this.viewModel.employee_id(),
			notifications_ids: [this.bindings.data.notifications_id]
		};

		this.viewModel.data(data);

		// UPDATE READ STATUS
		let res = await Grape.fetches.postJSON('/notifications/read_receipt_notification', data);
		if (res.status !== 'ERROR')
			Navbar.updateNotificationCount();
		else
			Grape.alerts.alert({type: 'error', title: 'Error', message: tr('Error occurred while updating notification count...')});
	};
};

export default {
	name: 'OpenNotification',
	dialog_class: OpenNotification,
	template: template,
	template_filename: 'translation/dialogs/open_notification_dialog',
	provider: 'ps'
};
